import { render } from "./TelegramIcon.vue?vue&type=template&id=018d436f"
import script from "./TelegramIcon.vue?vue&type=script&lang=js"
export * from "./TelegramIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__